import { retFlexColumns, subventionColumns } from '../_helpers/columns'
export default {
  setTableColumns: (state, payload) => {
    const { columns, table } = payload
    if (!columns && !table) return
    if (table === 'retFlexColumns') {
      state.retFlexColumns = payload.columns
    }
    if (table === 'subventionColumns') {
      state.subventionColumns = payload.columns
    }
  },
  initializeRetFlexColumns (state) {
    if ('retFlexColumns' in localStorage) {
      state.retFlexColumns = JSON.parse(localStorage.getItem('retFlexColumns'))
    } else {
      state.retFlexColumns = retFlexColumns
    }
  },
  initializeSubventionColumns (state) {
    if ('subventionColumns' in localStorage) {
      state.subventionColumns = JSON.parse(localStorage.getItem('subventionColumns'))
    } else {
      state.subventionColumns = subventionColumns
    }
  },
  resetColumns (state) {
    state.retFlexColumns = retFlexColumns
    state.subventionColumns = subventionColumns
    localStorage.removeItem('retFlexColumns')
    localStorage.removeItem('subventionColumns')
  }
}
